import {
    injectHelperFunctions,
    loadFromFilesystemWithCustomLoader
} from './lib/settings';

export const environment = (typeof window !== 'undefined' && window.CONFIG_ENV) || process.env.CONFIG_ENV || process.env.NODE_ENV || 'development';

const loader = file => {
    try {
        return require(`.${file}/config.json`);
    }
    catch (error) {
        return {};
    }
};

export const getConfigForEnvironment = (env = environment) => {
    return injectHelperFunctions(loadFromFilesystemWithCustomLoader(loader, env));
};

export const getConfigForAppdomain = (appdomain, env = environment) => {
    return injectHelperFunctions(loadFromFilesystemWithCustomLoader(loader, env, appdomain));
};
